/* eslint-disable complexity */
import { useContext } from 'react';
import '~/utils/prototypesExtensions';

import { Locale } from '@mindtickle/ui-shell-core/Intl';
import { Provider as LoggerProvider } from '@mindtickle/ui-shell-core/Logger';

import { ErrorBoundary } from '~/components/Tools';
import { LocalAuthContext } from '~/components/Auth';
import BaseDomainProvider from '~/components/BaseDomain';
import LocalAuthProvider from '~/components/Auth/LocalAuthProvider';

import { NAMESPACE } from '../constants';

const ComponentWithLocale = ({ children }: { children: JSX.Element }) => {
  const auth = useContext(LocalAuthContext);
  return <Locale.Provider locale={auth?.user.locale}>{children}</Locale.Provider>;
};

const ComponentRendererWithoutAuth = ({
  children,
  loader,
  baseDomain,
  appName,
}: {
  children: JSX.Element;
  loader?: JSX.Element;
  baseDomain?: string;
  appName: string;
}) => (
  <LoggerProvider namespace={NAMESPACE}>
    <ErrorBoundary>
      <BaseDomainProvider baseDomain={baseDomain}>
        <LocalAuthProvider>
          <ComponentWithLocale children={children} />
        </LocalAuthProvider>
      </BaseDomainProvider>
    </ErrorBoundary>
  </LoggerProvider>
);

export default ComponentRendererWithoutAuth;
